import { PlusIcon } from "lucide-react";

import { JobForm, TopbarContainer, TopbarTitle } from "@/components";

import { useCreateJob } from "@/hooks/mutations/useCreateJob";

export const JobCreatePage = () => {
  const { mutate: createJob } = useCreateJob();

  return (
    <>
      <TopbarContainer>
        <TopbarTitle>Jobs</TopbarTitle>
      </TopbarContainer>
      <div className="flex flex-col gap-10 p-10">
        <div className="flex flex-col gap-2">
          <p className="text-3xl font-semibold text-slate-700">Create job</p>
          <p className="text-sm font-medium text-slate-700">
            Define job details, compensation, and the job description
          </p>
        </div>
        <JobForm
          mutationFn={createJob}
          submitButtonIcon={<PlusIcon className="h-4 w-4" />}
          submitButtonText="Create job"
        />
      </div>
    </>
  );
};
